import React from 'react';

// helpers
import {useTranslation} from 'react-i18next';
import {ConfigManager} from '../../shared/services/ConfigManager';

// components
import {PageTemplate} from '../../shared/components';
import {CardPhoneNumberContact, CardEmailContact} from './components';

// styles
import {ContactPageWrapper} from './ContactPage-styles';

const ContactPage = () => {
  const {t} = useTranslation();
  const config = ConfigManager.getConfig();

  return (
    <PageTemplate title={t('contact_us')}>
      <ContactPageWrapper>
        <CardEmailContact supportEmail={config?.supportEmail} />
        <CardPhoneNumberContact
          supportPhoneNumber={config?.supportPhoneNumber}
        />
      </ContactPageWrapper>
    </PageTemplate>
  );
};
export default ContactPage;
